import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #FBF4EC 0%, #F5EDE4 60%, #EFE5D9 100%)'
  }} data-id="element-157">
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(196, 181, 253, 0.35)'
    }} data-id="element-158"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(252, 211, 211, 0.35)'
    }} data-id="element-159"></div>

      <div className="relative bg-white border border-[#E8D5C4] text-[#9D4D4D] font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-160">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#D97570] animate-pulse" data-id="element-161"></span>
        <span className="hidden sm:inline" data-id="element-162">
          🧘‍♀️ ATENCIÓN: INSTRUCTORAS DE PILATES CANSADAS DE SACRIFICAR SUS NOCHES
          PLANIFICANDO CLASES
        </span>
        <span className="sm:hidden" data-id="element-163">ATENCIÓN: INSTRUCTORAS DE PILATES</span>
      </div>

      <h1 className="relative font-black max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" style={{
      color: '#2A2438'
    }} data-id="element-164">
        Resuelve todo tu año de clases de Pilates en{' '}
        <span className="text-transparent bg-clip-text" style={{
        backgroundImage: 'linear-gradient(90deg, #8B6FBF 0%, #D98AA8 100%)'
      }} data-id="element-165">
          solo 5 minutos.
        </span>
      </h1>

      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/60 sm:backdrop-blur-sm sm:border sm:border-[#E8D5C4] sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm" style={{
      color: '#5C5470',
      borderLeftColor: '#8B6FBF'
    }} data-id="element-166">
        El Kit{' '}
        <span className="font-bold" style={{
        color: '#8B6FBF'
      }} data-id="element-167">
          "Abrir y Enseñar"
        </span>{' '}
        con clases listas para Reformer, Mat y Poblaciones especiales.{' '}
        <span className="hidden sm:inline font-semibold" style={{
        color: '#2A2438'
      }} data-id="element-168">
          Recupera tus fines de semana.
        </span>
      </p>

      <div className="relative w-full max-w-[340px] sm:max-w-[520px] md:max-w-[640px] mx-auto mb-4 sm:mb-8" data-id="element-169">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(196, 181, 253, 0.25)'
      }} data-id="element-170"></div>
        <img src="https://cdn.magicpatterns.com/uploads/wb9NtNCQ17ADTxz8Vm5pUc/15002B_CLIENTE_SODDISFATTI_(5).png" alt="MEGAPACK PILATES LISTO — Kit Integral de Movimiento" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(90,70,120,0.25)]" width={500} height={500} fetchPriority="high" loading="eager" decoding="async" data-id="element-171" />
      </div>

      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-172">
        <div className="flex items-center gap-2" data-id="element-173">
          <span className="text-sm sm:text-lg" style={{
          color: '#E0A52E'
        }} data-id="element-174">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-xs sm:text-base font-medium" style={{
          color: '#5C5470'
        }} data-id="element-175">
            4.9/5 (+800 Reseñas Verificadas)
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-3 py-1 rounded-full border" style={{
        color: '#A0651D',
        backgroundColor: '#FDF4E3',
        borderColor: '#E8D5C4'
      }} data-id="element-176">
          🔥 62 instructoras han elegido este Kit hoy
        </span>
      </div>

      <a href="#pricing" className="relative btn-primary-pulse font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white" style={{
      backgroundColor: '#0F8B6F'
    }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0B6E58'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#0F8B6F'} data-id="element-177">
        🚀 ¡SÍ! QUIERO RECUPERAR MI TIEMPO
      </a>

      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" style={{
      color: '#5C5470'
    }} data-id="element-178">
        <span data-id="element-179">⚡ Acceso Inmediato</span>
        <span data-id="element-180">•</span>
        <span data-id="element-181">🛡️ Garantía 7 Días</span>
        <span data-id="element-182">•</span>
        <span data-id="element-183">💳 Pago Único</span>
      </p>
    </section>;
}